module.exports = __webpack_public_path__ + "94998475f6aea65f558494802416c1cf.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Thin.ttf
// module id = 66
// module chunks = 0